import { isFeature } from 'Cloud/Application/FeaturesEs6';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

export const beforeRenewEnabled = isFeature('before-renew-enabled');

registerExperiment(
    'before-renew',
    beforeRenewEnabled ? 'on' : 'off',
    [
        AnalyticEventNames.BEFORE_RENEW_MODAL_SHOW,
        AnalyticEventNames.BEFORE_RENEW_MODAL_CLICK,
        AnalyticEventNames.BEFORE_RENEW_MODAL_CLOSE,
        AnalyticEventNames.BEFORE_RENEW_MODAL_CANCEL,
    ],
    {
        mapEventNames: {
            BEFORE_RENEW_MODAL_SHOW: 'show',
            BEFORE_RENEW_MODAL_CLICK: 'click',
            BEFORE_RENEW_MODAL_CLOSE: 'close',
            BEFORE_RENEW_MODAL_CANCEL: 'cancel',
        },
    }
);
